import { render, staticRenderFns } from "./facet.component.vue?vue&type=template&id=15022f9a&scoped=true"
import script from "./facet.component.vue?vue&type=script&lang=ts"
export * from "./facet.component.vue?vue&type=script&lang=ts"
import style0 from "./facet.component.vue?vue&type=style&index=0&id=15022f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15022f9a",
  null
  
)

export default component.exports